// Modal simple para crear menu semanal (Sprint 8 mejora UX).
// Consume POST /nutricionista/menus existente desde Sprint 5.
import { useState } from 'react'
import type { MenuCreateBody } from '../../services/nutricionista'
import { ModalShell } from '../ui/ModalShell'

interface Props {
  onClose: () => void
  onSubmit: (body: MenuCreateBody) => Promise<void>
}

export default function NuevoMenuModal({ onClose, onSubmit }: Props) {
  const [codigo, setCodigo] = useState('')
  const [nombre, setNombre] = useState('')
  const [fechaInicio, setFechaInicio] = useState(() => new Date().toISOString().slice(0, 10))
  const [notas, setNotas] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    setError(null)
    setLoading(true)
    try {
      await onSubmit({
        codigo: codigo.trim().toUpperCase(),
        nombre: nombre.trim(),
        fecha_vigencia_inicio: fechaInicio,
        notas: notas.trim() || null,
      })
      onClose()
    } catch (err: any) {
      setError(err?.response?.data?.detail || err?.message || 'Error al crear menú')
    } finally {
      setLoading(false)
    }
  }

  return (
    <ModalShell
      title="Nuevo menú semanal"
      onClose={onClose}
      closeDisabled={loading}
      maxWidth={440}
    >
        <form onSubmit={handleSubmit} className="space-y-3">
          <div>
            <label className="block text-sm font-medium mb-1">Código *</label>
            <input
              type="text"
              value={codigo}
              onChange={(e) => setCodigo(e.target.value)}
              required
              maxLength={20}
              placeholder="MENU-2026-V2"
              className="w-full p-2 border rounded uppercase focus:outline-none focus:ring-2 focus:ring-avante-primary"
            />
            <p className="text-xs text-gray-500 mt-1">Se guarda en MAYÚSCULAS automáticamente</p>
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">Nombre *</label>
            <input
              type="text"
              value={nombre}
              onChange={(e) => setNombre(e.target.value)}
              required
              maxLength={200}
              placeholder="MENU SEMANAL AVANTE 2026 V2"
              className="w-full p-2 border rounded uppercase focus:outline-none focus:ring-2 focus:ring-avante-primary"
              style={{ textTransform: 'uppercase' }}
            />
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">Fecha vigencia inicio *</label>
            <input
              type="date"
              value={fechaInicio}
              onChange={(e) => setFechaInicio(e.target.value)}
              required
              className="w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-avante-primary"
            />
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">Notas</label>
            <textarea
              value={notas}
              onChange={(e) => setNotas(e.target.value)}
              rows={2}
              maxLength={500}
              placeholder="Origen, cambios respecto al anterior, etc."
              className="w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-avante-primary"
            />
          </div>
          {error && <p className="text-avante-danger text-sm">{error}</p>}
          <div className="flex gap-2 pt-2">
            <button
              type="button"
              onClick={onClose}
              disabled={loading}
              className="flex-1 px-4 py-2 border rounded font-medium hover:bg-gray-50 disabled:opacity-50"
            >
              Cancelar
            </button>
            <button
              type="submit"
              disabled={loading}
              className="flex-1 bg-avante-primary text-white px-4 py-2 rounded font-semibold hover:bg-avante-accent disabled:opacity-50"
            >
              {loading ? 'Creando...' : 'Crear menú'}
            </button>
          </div>
        </form>
    </ModalShell>
  )
}
